import React, { useState } from 'react';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar — receives a toggle callback so it can open the drawer */}
      <Navbar onMenuToggle={() => setIsMobileMenuOpen(true)} />

      {/* Sidebar — handles both desktop fixed panel and mobile drawer */}
      <Sidebar
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={() => setIsMobileMenuOpen(false)}
      />

      {/* Main content — no left offset on mobile, offset on lg+ */}
      <main className="lg:pl-64 pt-16">
        <div className="p-4 sm:p-6">{children}</div>
      </main>
    </div>
  );
};
